import React, { useState } from 'react';

export default function About(props) {
  return (
    <div className='container'>
      <h1>About section</h1>
      <p>Some stuff about 'get to know us!'</p>
    </div>
  );
}
